export const accountingNavItems = [
  {
    name: "Invoices",
    path: "/accounting/invoices",
    end: true,
    testId: "nav-item-accounting",
    group: "Accounting",
  },
  {
    name: "Audit Log",
    path: "/accounting/audit-log",
    end: true,
    testId: "nav-item-audit-log",
    group: "Accounting",
  },
  {
    name: "Accounts Receivable",
    path: "/accounting/accounts-receivable",
    testId: "nav-item-accounts-receivable",
    group: "Accounting",
  },
  {
    name: "Payments",
    path: "/accounting/payments",
    testId: "nav-item-payments",
    group: "Accounting",
  },
  {
    name: "Customers",
    path: "/accounting/customers",
    testId: "nav-item-builders",
    group: "Accounting",
  },
  {
    name: "Vendors",
    path: "/accounting/vendors",
    testId: "nav-item-vendors",
    group: "Accounting",
  },
];
